import { BillingCycleTypes } from '../../domain/invoice';

export class SalesStatsRequest {
    DateStart: Date;
    DateStop: Date;
    SalesRepID: number;
    ProductID: number;
    BillingCycle: BillingCycleTypes;
    IncludeFree: boolean;
}
